import { api } from '../../lib/api';
import type {
  AuthResponse,
  ChangePasswordRequest,
  CurrentUser,
  LoginRequest,
  LogoutRequest,
  EnrolPinRequest,
  PinStatus,
  SetPinRequest,
  SignInOutcome,
  VerifyPinRequest,
} from './authTypes';

/** Auth endpoints. Pages call this, never `fetch`. */
export const authApi = {
  /**
   * `skipRefresh` on the credential endpoints: a 401 here means the credentials are wrong,
   * not that the access token expired, so attempting a refresh would loop.
   */
  login: (request: LoginRequest) =>
    api<SignInOutcome>('/api/auth/login', { method: 'POST', body: request, skipRefresh: true }),

  /** The second leg: the challenge ticket, and the PIN it waits on. Anonymous — there is no
   * token yet, which is the whole point of the factor. */
  verifyPin: (request: VerifyPinRequest) =>
    api<AuthResponse>('/api/auth/pin/verify', { method: 'POST', body: request, skipRefresh: true }),

  /** The second leg for an account that must still CHOOSE a PIN. Completes the sign-in. */
  enrolPin: (request: EnrolPinRequest) =>
    api<AuthResponse>('/api/auth/pin/enrol', { method: 'POST', body: request, skipRefresh: true }),

  pinStatus: (signal?: AbortSignal) => api<PinStatus>('/api/auth/pin', { signal }),

  /** Sets or replaces the caller's own PIN. Requires their password. */
  setPin: (request: SetPinRequest) =>
    api<void>('/api/auth/pin', { method: 'POST', body: request }),

  logout: (request: LogoutRequest) =>
    api<void>('/api/auth/logout', { method: 'POST', body: request }),

  me: (signal?: AbortSignal) => api<CurrentUser>('/api/auth/me', { signal }),

  changePassword: (request: ChangePasswordRequest) =>
    api<void>('/api/auth/change-password', { method: 'POST', body: request }),
};
